/**
 * Values are i18n dictionary keys (not display text) — every consuming
 * component must resolve them with `t(...)` before rendering.
 */
export const typeOptions = new Map([
  ["Package", "filterAndSortListings.typePackages"],
  ["Treatment", "filterAndSortListings.typeTreatments"],
  ["Membership", "filterAndSortListings.typeMemberships"],
  ["Product", "filterAndSortListings.typeProducts"],
  ["ProductFromExternalSource", "filterAndSortListings.typeProducts"],
  ["GiftCard", "filterAndSortListings.typeGiftCards"],
] as const);

/**
 * Values are i18n dictionary keys (not display text) — every consuming
 * component must resolve them with `t(...)` before rendering.
 */
export const sortOptions = new Map([
  ["featured", "filterAndSortListings.sortFeatured"],
  ["bestsellers", "filterAndSortListings.sortBestSellers"],
  ["onsale", "filterAndSortListings.sortOnSale"],
  ["priceLowToHigh", "filterAndSortListings.sortPriceLowToHigh"],
  ["priceHighToLow", "filterAndSortListings.sortPriceHighToLow"],
  ["recentlyAdded", "filterAndSortListings.sortRecentlyAdded"],
] as const);

export type ListingSortOptions = Parameters<(typeof sortOptions)["get"]>[0];
